import { Box, Paper } from "@mui/material"
import { FilterAltOutlined } from "@mui-symbols-material/w300"
import type { FC } from "react"
import { useState } from "react"

import { useExportPayFile } from "../hooks/useExportPayFile"
import { usePayFileList } from "../hooks/usePayFileList"

import { PayFileFilterChips } from "./filters/PayFileFilterChips"
import { PayFileFilterDrawer } from "./filters/PayFileFilterDrawer"
import { PayFileCreateSection } from "./PayFileCreateSection"
import { PayFileTable } from "./PayFileTable"

import { Button } from "@/components/common/Button"

export const PayFileListPage: FC = () => {
  const [isFilterOpen, setIsFilterOpen] = useState(false)
  const { exportPayFile } = useExportPayFile()

  const {
    payFiles,
    isFetching,
    error,
    sorting,
    expanded,
    searchParams,
    tableContainerRef,
    refetch,
    handleScroll,
    handleSortingChange,
    handleExpandedChange,
    handleFilterChange,
    handleFiltersChange,
    handleFilterRemove,
    handleFilterClear,
  } = usePayFileList()

  return (
    <Box className='flex size-full flex-col'>
      <Paper elevation={0} className='flex min-h-0 grow flex-col gap-6 overflow-hidden bg-white'>
        <PayFileCreateSection onSuccess={refetch} />

        <Box className='flex items-center justify-start'>
          <Button
            appearance='outlined'
            startIcon={<FilterAltOutlined />}
            onClick={() => setIsFilterOpen(true)}
            rootElementName='button'
            data-testid='pay-file.filter-button'
          >
            Filter
          </Button>
        </Box>

        <PayFileFilterChips searchParams={searchParams} onRemove={handleFilterRemove} />

        <Box className='flex flex-1 flex-col overflow-y-auto'>
          <PayFileTable
            data={payFiles}
            sorting={sorting}
            onSortingChange={handleSortingChange}
            expanded={expanded}
            onExpandedChange={handleExpandedChange}
            loading={isFetching}
            error={error}
            onScroll={handleScroll}
            containerRef={tableContainerRef}
            onExport={exportPayFile}
            onSuccess={refetch}
          />
        </Box>

        <PayFileFilterDrawer
          open={isFilterOpen}
          onClose={() => setIsFilterOpen(false)}
          searchParams={searchParams}
          onChange={handleFilterChange}
          onBatchChange={handleFiltersChange}
          onClear={handleFilterClear}
        />
      </Paper>
    </Box>
  )
}
